export default __webpack_public_path__ + "static/media/wirecutter-newsletter-component.f0906cdd.png";